import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IIntegrationResponse } from "../../features/Configurations/Integration/interface";

/**
 * Normalize integration data to ensure platform-direction consistency.
 * Meta Ads is a spending (inward) source. If the backend has it in outwards
 * due to a previous bug, we move it to inwards on the client side.
 */
const normalizeIntegrationData = (data: IIntegrationResponse): IIntegrationResponse => {
  const SPENDING_PLATFORMS = ['google_ads', 'meta_ads'];
  const normalized: IIntegrationResponse = {};

  for (const [trackingId, integrationSet] of Object.entries(data)) {
    const inwards = [...(integrationSet.inwards || [])];
    const outwards = [...(integrationSet.outwards || [])];

    // Move any spending platforms accidentally saved in outwards → inwards
    const misplacedInOutwards = outwards.filter(s => SPENDING_PLATFORMS.includes(s.type));
    const correctedOutwards = outwards.filter(s => !SPENDING_PLATFORMS.includes(s.type));
    const correctedInwards = [
      ...inwards,
      ...misplacedInOutwards,
    ];

    normalized[trackingId] = {
      ...integrationSet,
      inwards: correctedInwards,
      outwards: correctedOutwards,
      inwards_count: correctedInwards.length,
      outwards_count: correctedOutwards.length,
    };
  }

  return normalized;
};

export const useIntegrations = () => {
  return useQuery({
    queryKey: ["integrations"],
    queryFn: async () => {
      const response = await httpService.get<IIntegrationResponse>(
        API_CONFIG.path.connectedAccounts
      );
      return normalizeIntegrationData(response);
    },
  });
};
